import React from "react";
import DropdownSelect from "../../dropdown/Dropdown";
import ActionDeleteButton from "../../UIComponent/ActionTableComponent/ActionDeleteButton";
import Validation from "../../../utils/validation/ValidationText";
import TextInput from "../../UIComponent/TextInput";
import DatePicker from "../../datePicker/DatePicker";
import moment from "moment";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
import ActionEditButton from "../../UIComponent/ActionTableComponent/ActionEditButton";
import BuyChapterModal from "./BuyChapterModal";

function ChapterInformation(props) {

  return (
    <div>
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 px-3 lg:py-7 lg:pt-5 pt-4">
        <div className="py-5">
          <div className="grid grid-cols-12 gap-6 w-full ">
            <div className="xl:col-span-12 lg:col-span-12 col-span-12">
              {props.chapterList.map((chapter, key) => (
                // <h1 className="col-span-2 text-white text-[16px] font-bold ml-14 mb-2" key={key}>
                <div
                  key={key}
                  className="slected-chapter flex items-start justify-between table-bg p-5 lg:py-3 mb-3 mt-1 overflow-auto"
                >
                  <div className="left-name font-bold text-white text-lg text-left w-[50%]">
                    <div className="flex flex-col">
                      <span className="w-[180px] 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Selected Chapter:
                      </span>
                      <span className="flex  w-[70%] pr-3 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {chapter.groupName}
                      </span>
                    </div>
                  </div>
                  <div className="left-name font-bold text-white text-lg text-left lg:w-[20%] w-[100%]">
                    <div className="flex flex-col justify-start">
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Joined at:
                      </span>
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {moment(chapter.joinDate).format("DD/MM/yyyy")}
                      </span>
                    </div>
                  </div>
                  <div className="left-name font-bold text-white text-lg text-left w-[50%]">
                    <div className="flex flex-col">
                      <span className="w-[180px] 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Chapter Representative Email:
                      </span>
                      <span className="flex  w-[70%] pr-3 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {chapter.email}
                      </span>
                    </div>
                  </div>
                  <div className="left-name font-bold text-white text-lg text-left lg:w-[20%] w-[100%]">
                  </div>
                  <div className="right-action lg:w-[10%] w-[100%] lg:ml-0 ml-5">
                    <div className="flex justify-center items-center pt-2">


                      <ActionEditButton
                        value=""
                        id=""
                        index=""
                        onActionClick={() =>
                          props.getChapterInformation(chapter.corporateChapterId)
                        }
                        text=""
                      />
                    </div>
                  </div>
                  <div className="right-action lg:w-[10%] w-[100%] lg:ml-0 ml-5">
                    <div className="flex justify-center items-center pt-2">
                      <ActionDeleteButton
                        value=""
                        id=""
                        index=""
                        onActionClick={() =>
                          props.deleteChapter(chapter.corporateChapterId)
                        }
                        text="Delete"
                      />
                    </div>
                  </div>

                </div>
                // </h1>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-12 2xl:gap-6 xl:gap-6 md:gap-6 gap-3 w-full ">
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                Number of Chapter:{" "}
                <span className="ml-5">
                  {props.chapterInformation.availableChapters ? props.chapterInformation.availableChapters : "0"} Available
                </span>
              </h2>
            </div>
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                Joined Chapters:{" "}
                <span className="ml-5">
                  {props.chapterInformation.joinedChapters ? props.chapterInformation.joinedChapters : "0"} Available
                </span>
              </h2>
            </div>
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-3">
                Complimentary Chapters:{" "}
                <span className="ml-5">
                  {/* {(props.chapterInformation.joinedChapters + props.chapterInformation.availableChapters) - props.chapterInformation.purchasedChapters} Available */}
                  {props.chapterInformation.complementaryChapter} Available
                </span>
              </h2>
            </div>
          </div>
          {props.availableChapterListForUpcomingTenure && props.availableChapterListForUpcomingTenure.length > 0 ?
            <div className="grid grid-cols-12 gap-6 w-full ">
              <div className="xl:col-span-12 lg:col-span-12 col-span-12 ">
                <span className="text-xl font-bold mb-3 text-[#c00000]">Note:</span>
                {props.availableChapterListForUpcomingTenure.map((chapter, key) => {
                  return (
                    <h2 className="text-xl text-[#757575] font-bold mb-3 ml-6" key={key}>
                      You will have {chapter.complementaryChapter + chapter.purchaseChapter} chapters for the new subscription period {moment(chapter.chapterStartDate).format("DD MMM yyyy")} to {moment(chapter.chapterEndDate).format("DD MMM yyyy")}
                    </h2>
                  )
                })}
              </div>
            </div>
            : null}
        </div>
        <div className="lg:pb-10 md:mb-5 sm:mb-5 pb-5">
          <div className="grid grid-cols-12 gap-6 w-full ">
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12">
                  <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                    Chapter Name
                    <span className="text-[#c00000]">*</span>
                  </h2>

                  <DropdownSelect
                    drpIdentity={"Chapters"}
                    optionArray={props.chaptersList}
                    setFilterParameters={props.setFilterParameters}
                    value={props.chapterInformation.workgroupMappingId}
                    onBlur={(e) => props.validate("workgroupMappingId", props.chapterInformation)}
                    disabled={props.chapterInformation.isEditTrue} // Disable if isEditTrue is true

                  />
                  <Validation error={props.validState.error.workgroupMappingId} />
                </div>
              </div>
            </div>

            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12">
                  <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                    Updated By
                  </h2>
                  <DropdownSelect
                    disabled={true}
                    drpIdentity={"UpdatedBy"}
                    optionArray={props._by}
                    setFilterParameters={props.setFilterParameters}
                    value={props.chapterInformation.updatedBy}
                  //onBlur={(e) => props.validate("updatedBy", props.chapterInformation)}
                  />
                  {/* <Validation error={props.validState .error.updatedById} /> */}
                </div>
              </div>
            </div>
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12">
                  <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                    Chapter Representative Email <span className="text-[#c00000]">*</span>
                  </h2>
                  <DropdownSelect
                    drpIdentity={"organisationEmailForChapter"}
                    optionArray={props.Organisationemail}
                    setFilterParameters={props.setFilterParameters}
                    value={props.chapterInformation.emailId === 0 ? props.repOfficialInformation.emailID : props.chapterInformation.emailId}
                    //onBlur={(e) => props.validate("updatedBy", props.chapterInformation)}
                    isRemoveDefaultOption={(props.chapterInformation.emailId > 0 || props.repOfficialInformation.emailID > 0) ? true : false}
                  />
                  <Validation error={props.validState.error.emailId} />
                </div>
              </div>
            </div>
            <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12">
                  <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                    Last Updated Date
                  </h2>
                  <div className="disabled-input">
                    {props.chapterInformation.updatedAt === "" || props.chapterInformation.updatedAt === null ?

                      <TextInput
                        disabled={true}
                        placeholder=""
                        type="text"
                        name="linkedIn"
                        value="None"
                        identity="BasicInformation"
                      />
                      :
                      <DatePicker
                        isDisable={true}
                        name="updatedAt"
                        handleChange={props.handleChange}
                        identity="updatedAt"
                        value={moment(props.chapterInformation.updatedAt).format("yyyy-MM-DD")}
                      />
                    }
                  </div>
                  {/* <div className="disabled-input">
                    <DatePicker
                      name="updatedDate"
                      isDisable={true}
                      handleChange={props.handleChange}
                      identity="SIISInformation"
                      value={moment(props.chapterInformation.updatedAt).format("yyyy-MM-DD")}
                    />
                  </div> */}
                </div>
              </div>
            </div>
            <div className="xl:col-span-12 lg:col-span-12 col-span-12">
              <div className="grid grid-cols-12 gap-6">
                <div className="xl:col-span-12 lg:col-span-12 col-span-12 2xl:mt-0 lg:mt-0 2xl:pt-6 xl:pt-6 lg:pt-0 md:pt-0 sm:pt-0 pt-0 pr-0">
                  {/* Edit mode buttons: Cancel + Update */}
                  {props.chapterInformation.isEditTrue ? (
                    <div className="flex justify-end gap-3 mt-4">
                      <button
                        className="w-36 btn-red bg-gray-500 px-6 py-3 text-xl font-semibold rounded-lg text-white"
                        onClick={() => props.onCancel()}
                      >
                        Cancel
                      </button>
                      {props.isLoadingForJoinChapter ? <ButtonLoader /> :
                      <button
                        className="w-36 btn-red bg-red-600 px-6 py-3 rounded-lg text-xl font-semibold text-white"
                        onClick={() => props.updateChapterById()}
                      >
                        Update
                      </button>
                      }
                    </div>
                  ) : (
                    /* Join button */
                    <div className="flex justify-end mt-4">
                      {props.isLoadingForJoinChapter ? <ButtonLoader /> :
                      <button
                        className={`btn-red w-36 px-6 py-3 rounded-lg text-xl font-semibold text-white ${new Date(props?.membershipSubscription?.subcriptionEndDate) <= new Date()
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-red-600"
                          }`}
                        disabled={
                          new Date(props?.membershipSubscription?.subcriptionEndDate) <= new Date()
                        }
                        onClick={() => props.save()}
                      >
                        Join
                      </button>
                      }
                    </div>
                  )}

                  {/* Buy Chapter button */}
                  <div className="flex justify-end mt-4">
                    <button
                      className={`btn-red px-6 py-3 w-36 rounded-lg text-xl font-semibold text-white ${new Date(props?.membershipSubscription?.subcriptionEndDate) <= new Date()
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-red-600"
                        }`}
                      disabled={
                        new Date(props?.membershipSubscription?.subcriptionEndDate) <= new Date()
                      }
                      onClick={() => props.buyChapter()}
                    >
                      Buy Chapter
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <div className="xl:col-span-12 lg:col-span-12 col-span-12">
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  History :{props.deletedChapterList?.length === 0 ? "-" : ""}
                </h2>
              </div>
              {props.deletedChapterList.map((chapter, key) => (
                // <h1 className="col-span-2 text-white text-[16px] font-bold ml-14 mb-2" key={key}>
                <div
                  key={key}
                  className="slected-chapter flex gap-5 items-start justify-between table-bg p-5 lg:py-3 mt-1 overflow-auto"
                >
                  <div className="left-name font-bold text-white text-lg text-left lg:w-[50%]">
                    <div className="flex flex-col">
                      <span className="w-[180px] 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Selected Chapter:
                      </span>
                      <span className="flex break-all w-[70%] pr-3 2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {chapter.groupName}
                      </span>
                    </div>
                  </div>
                  <div className="left-name font-bold text-white text-lg text-left lg:w-[20%] w-[100%]">
                    <div className="flex flex-col justify-center">
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Joined at:
                      </span>
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {moment(chapter.joinDate).format("DD/MM/yyyy")}
                      </span>
                    </div>
                  </div>
                  {/* {chapter.leftDate ? */}
                  <div className="left-name font-bold text-white text-lg text-left lg:w-[20%] w-[100%]">
                    <div className="flex flex-col justify-start ">
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        Left at:
                      </span>
                      <span className="2xl:text-[18px] lg:text-[18px] xl:text-[18px] text-[16px] whitespace-nowrap">
                        {moment(chapter.leftDate).format("DD/MM/yyyy")}
                      </span>
                    </div>
                  </div>
                  <div className="right-action lg:w-[10%] w-[100%]">
                    <div className="flex justify-center items-center pt-2">
                    </div>
                  </div>
                </div>
                // </h1>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="add-edite-profile-popup">
        <BuyChapterModal
          key={"BuyChapterModal"}
          setBuyChapterModal={props.setBuyChapterModal}
          chapterListArr={props.chapterListArr}
          purchaseChapter={props.purchaseChapter}
          setOpenModal={props.setOpenModal}
          //onClose={() => props.closeBuyChapterModal}
          setBuyChapterFilterParameters={(id, drpIdentity) =>
            props.setBuyChapterFilterParameters(id, drpIdentity)
          }
          buyChapterForCorporateMember={() => {
            props.buyChapterForCorporateMember()
          }
          }
          paymentsMethods={props.paymentsMethods}
          buyChapterValidState={props.buyChapterValidState}
          loadingForPayment={props.loadingForPayment}
          responseMessage={props.responseMessage}
          discountedAmount={props.discountedAmount}
          handleChangeForBuyChapter={(e) => props.handleChangeForBuyChapter(e)}
          handleChangeInPoNumber={props.handleChangeInPoNumber}
          applyVoucherCodeForAdditionalChapter={props.applyVoucherCodeForAdditionalChapter}
          removePromoCode={props.removePromoCode}
          isFixedPrice={props.isFixedPrice}
          gstRate={props.gstRate}

        />
      </div>
    </div>
  );
}

export default ChapterInformation;

